var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLogoutWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0511 10.4545L9.51136 19.0455L0.869318 10.4545L9.51136 1.86364L18.0511 10.4545ZM16.0696 10.4545L9.50497 3.85156L2.86364 10.4545L9.50497 17.0575L16.0696 10.4545Z",
    fill: "#F95A61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6548 8.76646L13.7973 8.92623H10H9V9.92623V11.0328V12.0328H10H13.7421L13.6215 12.1632L14.2165 12.8404L14.9367 13.66L15.6688 14.4934L16.422 13.679L18.4228 11.5157C18.9512 10.9443 18.9549 10.0636 18.4311 9.48784L16.4655 7.32709L15.7319 6.52062L14.9916 7.32102L14.2715 8.09971L13.6548 8.76646Z",
    fill: "#F95A61",
    stroke: "#f5f8fa",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutWhite);
export default __webpack_public_path__ + "static/media/logout-white.a1dee940e31e720670e63ee2193273a2.svg";
export { ForwardRef as ReactComponent };